(() => {
  const popularCountryCodes = ['AU', 'CA', 'NZ', 'GB', 'US'];
  const popularCountrySet = new Set(popularCountryCodes);

  const reorderMenu = (form) => {
    const menu = form.querySelector('.thb-country-selector-menu');
    if (!menu) return;

    const options = Array.from(menu.querySelectorAll('.thb-country-option'));
    if (!options.length) return;

    const optionByCode = new Map(
      options.map((option) => [String(option.dataset.countryCode || '').toUpperCase(), option])
    );
    const popularOptions = popularCountryCodes
      .map((code) => optionByCode.get(code))
      .filter(Boolean);
    const remainingOptions = options.filter((option) => {
      const code = String(option.dataset.countryCode || '').toUpperCase();
      return !popularCountrySet.has(code);
    });

    const fragment = document.createDocumentFragment();
    popularOptions.forEach((option) => fragment.appendChild(option));

    if (popularOptions.length && remainingOptions.length) {
      const divider = document.createElement('div');
      divider.className = 'thb-country-option-divider';
      divider.setAttribute('role', 'separator');
      divider.style.cssText = 'height:1px;margin:6px 10px;background:rgba(255,255,255,0.18);';
      fragment.appendChild(divider);
    }

    remainingOptions.forEach((option) => fragment.appendChild(option));
    menu.replaceChildren(fragment);
  };

  const reorderNativeSelect = (form) => {
    const select = form.querySelector('select[name="country_code"]');
    if (!select) return;

    const selectedValue = select.value;
    const options = Array.from(select.options);
    const optionByCode = new Map(
      options.map((option) => [String(option.value || '').toUpperCase(), option])
    );
    const popularOptions = popularCountryCodes
      .map((code) => optionByCode.get(code))
      .filter(Boolean);
    const remainingOptions = options.filter((option) => {
      const code = String(option.value || '').toUpperCase();
      return !popularCountrySet.has(code);
    });

    const fragment = document.createDocumentFragment();
    popularOptions.forEach((option) => fragment.appendChild(option));
    remainingOptions.forEach((option) => fragment.appendChild(option));
    select.replaceChildren(fragment);
    select.value = selectedValue;
  };

  const reorderForm = (form) => {
    reorderMenu(form);
    reorderNativeSelect(form);
  };

  const update = (root = document) => {
    if (root instanceof Element && root.matches('.thb-localization-forms.inside-header')) {
      reorderForm(root);
    }

    root.querySelectorAll?.('.thb-localization-forms.inside-header').forEach(reorderForm);
  };

  update(document);
  document.addEventListener('shopify:section:load', (event) => update(event.target));
})();
